import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-auto">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="bg-gray-100 p-1.5 rounded-md">
              <SafeIcon icon={FiIcons.FiShield} className="text-blue-600 text-sm" />
            </div>
            <span className="text-sm font-semibold text-gray-900">
              Exif<span className="text-blue-600">Investigator</span>
            </span>
          </div>

          <div className="text-sm text-gray-500 flex flex-col items-center md:items-end">
            <p>© {currentYear} All Rights Reserved</p>
            <p className="font-medium mt-1">
              Developed by <a href="https://takedowntaskforce.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">takedowntaskforce.com</a>
            </p>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-50 text-center">
          <p className="text-[10px] text-gray-400 uppercase tracking-widest font-bold">
            Secure Local-Only Metadata Forensic Suite
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;